import wowImageFactory from './WowImage';
export default function init() {
    const elementName = 'wow-image';
    if (customElements.get(elementName) === undefined) {
        let resizeObserver;
        if (window.ResizeObserver) {
            resizeObserver = new window.ResizeObserver((entries) => {
                entries.map((entry) => entry.target.reLayout());
            });
        }
        return function (services, env) {
            const WowImage = wowImageFactory(Object.assign({ resizeService: resizeObserver }, services), env);
            customElements.define(elementName, WowImage);
        };
    }
    return;
}
//# sourceMappingURL=registry.js.map